module.exports = __webpack_public_path__ + "files/a874862546d9f98e441da9c5481f4e6a.png";